<template>
  <div class="w-full flex justify-center">
    <div class="main-container">
     <GoBackButton />
      <div class="heading pb-6 flex items-center">
        <h2 class="font-normal text-zt-primary-200">{{ $t('message.abm.folders.title') }}</h2>
      </div>
      <div class="main rounded">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import GoBackButton from '@/components/generics/GoBackButton.vue';
export default {
  name: 'FoldersMain',
  components: {
   GoBackButton
  }
};
</script>
<style scoped lang="scss">
.main-container {
  width: 844px;
  height: calc(100vh - 120px);
  .heading {
    height: 50px;
    h2 {
      color: #707070;
      font-size: 24px;
    }
  }
  .main {
    height: calc(100% - 50px);
    background: white;
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12), 0 1px 8px rgba(0, 0, 0, 0.2);
    overflow: hidden;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
